<micro-lookup domain="voice" obj="voiceCarriers" url="/voice/voiceCarriers" [key]="voiceCarrierId"></micro-lookup>
